import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';
import * as MyAccountService from 'services/myAccount';
import { message } from 'antd';
import { verificationTokenType } from 'types/verificationToken.type';
import { getApiLanguageValue } from 'utils/functionUtils';
import { RootModel } from '../models';
import { storeName as layoutModelStore } from './layout.model';

export const storeName = 'verificationTokenModel';

type VerificationTokenModelTypes = {
  verificationToken: verificationTokenType;
  loading: boolean;
};

const initialState: VerificationTokenModelTypes = {
  verificationToken: undefined,
  loading: false,
};

export const verificationTokenModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setVerificationToken: produce((state, payload: boolean) => {
      state.verificationToken = payload;
    }),
    updateLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: RematchDispatch) => ({
    async getUserVerifyingEmail() {
      this.updateLoading(true);
      return MyAccountService.getUserVerifyingEmail()
        .then((res: any) => {
          const { data } = res;
          this.setVerificationToken(data);

          return data;
        })
        .catch((err: any) => {
          console.error('getUserVerifyingEmail:', err);
        })
        .finally(() => this.updateLoading(false));
    },

    async cancelVerifyEmail() {
      this.updateLoading(true);

      try {
        await MyAccountService.cancelVerifyEmail();
        this.getUserVerifyingEmail();
        message.success('Cancel verify email success.');
      } catch (e) {
        console.error(e);
        message.error('Fail to cancel verify email.');
      } finally {
        this.updateLoading(false);
      }
    },

    async resendVerificationEmail(payload, state: RootModel) {
      this.updateLoading(true);
      const { locale } = state[layoutModelStore];

      try {
        await MyAccountService.resendVerificationEmail(getApiLanguageValue(locale));
        this.getUserVerifyingEmail();
        message.success('Resend verify email success.');
      } catch (e) {
        console.error(e);
        message.error('Fail to resend verify email.');
      } finally {
        this.updateLoading(false);
      }
    },
  }),
});

export default verificationTokenModel;
